// extracted by mini-css-extract-plugin
module.exports = {"NavigationList":"NavigationList_NavigationList__2OR5T"};